import {API_URL} from "../config";
import axios from "../utils/axios";

class UserRepository
{
    save(data) {
        return axios.post(API_URL + "/User/Save", data);
    }

    getAll(filter) {
        return axios.get(API_URL + "/User/List?", {params: filter});
    }

    getById(id) {
        return axios.get(API_URL + `/User/${id}`);
    }

    delete(id) {
        return axios.delete(API_URL + `/User/${id}`);
    }
}

export default UserRepository;